import React from "react";
import { FaCheck } from "react-icons/fa6";

const ReadOnlyPermissionCheckboxTree = ({ data }) => {
  if (!data) return null;

  const categoryInactive = !data.checked;

  return (
    <section className="CheckboxTree kmb-8 permission-readonly-tree">
      <div className="first">
        <label className="custom-checkbox">
          <input type="checkbox" checked={!!data.checked} readOnly tabIndex={-1} />
          <span className={`checkMarkB kmr-5${categoryInactive ? " banned" : ""}`}>
            {!categoryInactive ? <FaCheck className="tx-ff" /> : null}
          </span>
          <span className={`fzl-16 fw-7${categoryInactive ? " tx-88" : ""}`}>
            {data.label}
          </span>
        </label>
      </div>
      <div className="second">
        {(data.children || [])
          .filter((util) => !util.hidden)
          .map((util) => {
            if (util.sectionHeaderOnly) {
              return (
                <div key={`sec-${util.label}`} className="util-item">
                  <span className="fzl-14 fw-7 tx-88 kmt-8 kmb-2 d-block">
                    {util.label}
                  </span>
                </div>
              );
            }

            const rowChecked = util.checked;
            const line1 = util.displayLabel || util.label;
            const visibleDetails = (util.children || []).filter(
              (detail) => !detail.hidden
            );
            const rowInactive = categoryInactive || !rowChecked;

            return (
              <div className="util-item" key={util.label + (util.id || "")}>
                {util.layerTwoSubline ? (
                  <div className="layer-two-stack">
                    <label className="layer-two custom-checkbox">
                      <input
                        type="checkbox"
                        checked={rowChecked}
                        readOnly
                        tabIndex={-1}
                      />
                      <span
                        className={`checkMarkG kmr-5${rowInactive ? " banned" : ""}`}
                      >
                        {!rowInactive ? <FaCheck className="tx-ff" /> : null}
                      </span>
                      <span className={`fzl-14${rowInactive ? " tx-88" : ""}`}>
                        {line1}
                      </span>
                    </label>
                    <div className="layer-two-stack__subline">
                      {util.layerTwoSubline}
                    </div>
                  </div>
                ) : (
                  <label className="layer-two custom-checkbox">
                    <input
                      type="checkbox"
                      checked={rowChecked}
                      readOnly
                      tabIndex={-1}
                    />
                    <span
                      className={`checkMarkG kmr-5${rowInactive ? " banned" : ""}`}
                    >
                      {!rowInactive ? <FaCheck className="tx-ff" /> : null}
                    </span>
                    <span className={`fzl-14${rowInactive ? " tx-88" : ""}`}>
                      {line1}
                    </span>
                  </label>
                )}

                <div className="util-item-methods">
                  {visibleDetails.map((detail) => {
                    const methodInactive =
                      categoryInactive || !util.checked || !detail.checked;
                    const detailLine = detail.displayLabel || detail.label;
                    return (
                      <label
                        className={`layer-three custom-checkbox
                          ${
                            ["關帳紀錄", "關帳"].includes(detail.label) &&
                            "ww-fix op10"
                          }
                          ${
                            ["手機號碼顯示"].includes(detail.label) &&
                            "w-fix-6"
                          }`}
                        key={`${util.label}-${detail.label}`}
                      >
                        <input
                          type="checkbox"
                          checked={!!detail.checked}
                          readOnly
                          tabIndex={-1}
                        />
                        <span
                          className={`checkMarkR kmr-5${
                            methodInactive ? " banned" : ""
                          }`}
                        >
                          {!methodInactive ? (
                            <FaCheck className="tx-ff" />
                          ) : null}
                        </span>
                        <span
                          className={`fzl-14${methodInactive ? " tx-88" : ""}`}
                        >
                          {detailLine}
                        </span>
                      </label>
                    );
                  })}
                </div>
              </div>
            );
          })}
      </div>
    </section>
  );
};

export default ReadOnlyPermissionCheckboxTree;
